"use client";

import { useEffect } from "react";
import { getUTMCookie, setUTMCookie } from "@/lib/authCookieServer";

/** Persists UTM query params into first/last channel cookies for attribution. */
export function UtmChannelCapture() {
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const utmSource = searchParams.get("utm_source")?.trim() || "";
    const utmMedium = searchParams.get("utm_medium")?.trim() || "";
    const utmCampaign = searchParams.get("utm_campaign")?.trim() || "";
    const utmContent = searchParams.get("utm_content")?.trim() || "";
    const utmTerm = searchParams.get("utm_term")?.trim() || "";
    const utmId = searchParams.get("utm_id")?.trim() || "";
    const fbclid = searchParams.get("fbclid")?.trim() || "";
    const gclid = searchParams.get("gclid")?.trim() || "";

    const THIRTY_DAYS_IN_SECONDS = 30 * 24 * 60 * 60;
    const setUtmCookies = (key: string, value: string) => {
      if (!value) return;
      const firstKey = `first_channel_${key}`;
      const lastKey = `last_channel_${key}`;
      const firstExists = getUTMCookie(firstKey);
      if (!firstExists) {
        setUTMCookie(firstKey, value, THIRTY_DAYS_IN_SECONDS);
      }
      setUTMCookie(lastKey, value);
    };

    setUtmCookies("source", utmSource);
    setUtmCookies("medium", utmMedium);
    setUtmCookies("campaign", utmCampaign);
    setUtmCookies("content", utmContent);
    setUtmCookies("term", utmTerm);
    setUtmCookies("id", utmId);
    setUtmCookies("fbclid", fbclid);
    setUtmCookies("gclid", gclid);
  }, []);

  return null;
}
